module.exports = __webpack_public_path__ + "6bc8623ea0e88e0aa57bff095bc5dae4.pdf";